import React from 'react';
import { CloseIcon } from '@chakra-ui/icons';
import {
  Button,
  Center,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';

import { DialogProps } from 'clipsal-cortex-types/src/common/chakra-extension-types';

import { UploadBillContents } from './UploadBillContents';

type UploadBillsProps = { onResetBills: () => void; billUrl?: string | null; onClose: () => void };
type UploadBillDialogProps = DialogProps & UploadBillsProps;

export function UploadBillModal({ isOpen, onClose, onResetBills }: UploadBillDialogProps) {
  return (
    <Modal scrollBehavior={'inside'} size={'xl'} isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent data-testid="upload-bills-modal-body">
        <ModalHeader as={Center}>Upload bill</ModalHeader>
        <ModalCloseButton data-testid="upload-bills-close-btn" />
        <ModalBody>
          <UploadBillContents data-testid="upload-bills-modal-contents" onResetBills={onResetBills} onClose={onClose} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export function UploadBillBottomDrawer({ isOpen, onClose, onResetBills, billUrl }: UploadBillDialogProps) {
  const drawerHeaderBorderColor = useColorModeValue('dusk005.500', 'borderGrey.500');
  return (
    <Drawer onClose={onClose} placement={'bottom'} isOpen={isOpen} id={'uploadBillDrawer'}>
      <DrawerOverlay />
      <DrawerContent data-testid="upload-bills-drawer-content">
        <DrawerHeader borderBottomWidth={10} borderColor={drawerHeaderBorderColor}>
          <Center position="relative">
            <Button variant="ghost" onClick={onClose} left={0} position="absolute" size="sm">
              <CloseIcon w={[3, 4]} h={[3, 4]} />
            </Button>
            <Text>Upload bill</Text>
          </Center>
        </DrawerHeader>
        <DrawerBody px={1}>
          <UploadBillContents onResetBills={onResetBills} onClose={onClose} billUrl={billUrl} />
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
}
